import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-dropdown"
export default class extends Controller {
  static targets = ["menu", "button"]
  
  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
  }
  
  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }
  
  toggle(event) {
    event.stopPropagation()
    event.preventDefault()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    // Don't close other dropdowns - this is specifically for nested dropdowns
    this.menuTarget.classList.remove("hidden")
    
    // Delay adding the click listener to avoid immediate closure
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnClickOutside)
    }, 100)
    
    // Add entrance animation
    this.menuTarget.style.opacity = "0"
    this.menuTarget.style.transform = "scale(0.95) translateY(-10px)"
    
    requestAnimationFrame(() => {
      this.menuTarget.style.transition = "all 0.1s ease-out"
      this.menuTarget.style.opacity = "1"
      this.menuTarget.style.transform = "scale(1) translateY(0)"
    })
  }
  
  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }
  
  closeOnClickOutside(event) {
    // Only close if clicking completely outside this element and not on parent dropdown items
    if (!this.element.contains(event.target) && 
        !event.target.closest('.user-section')) {
      this.close()
    }
  }
}